class SnackBarService {
  public show: boolean = false;

  public timeout: number = 6000 ;

  public message: string = 'Error';

  public color: string = 'error';

  open(data: any) {
    this.show = data.show === true;
    this.timeout = data.timeout || 6000;
    this.message = data.message;
    this.color = data.color || 'error';
    setTimeout(() => {
      this.show = false;
    }, this.timeout);
  }

  errorMessage(err: any) {
    const data = {
      show: true,
      message: err.toString(),
    };
    return this.open(data);
  }

  successMessage(response: any) {
    const data = {
      show: true,
      color: 'success',
      message: response.toString(),
    };
    return this.open(data);
  }

  errorMessageToString(response: any) {
    const data = {
      show: true,
      color: 'error',
      message: response.toString(),
    };
    return this.open(data);
  }
}
export default new SnackBarService();
